import HeroSection from "./components/HeroSection";
import AnnouncementsSection from "./components/AnnouncementsSection";
import QuickAccessSection from "./components/QuickAccessSection";
import NewsSection from "./components/NewsSection";
import ActivitiesSection from "./components/ActivitiesSection";

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <AnnouncementsSection />
      <QuickAccessSection />
      <NewsSection />
      <ActivitiesSection />
    </main>
  );
}
